/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { ScreenControllerTypes } from '../../core/navigation/ScreenControllerTypes';
import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import { NetworkManager } from '../../core/network/NetworkManager';
import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { disableGhostMode, enableGhostMode } from '../guide/guidehighlight/guidehighlight.reducers';
import { showNoNetworkOverlay } from '../overlay/nonetworkoverlay/nonetworkoverlay.reducers';
import { setScreenController, setScreenTaskController } from '../screens/screens.reducers';
import { setIsSidebarNavigationMenuActiveAction } from './sidebarnavigationmenu.actions';
import { IS_SIDEBAR_NAVIGATION_MENU_ACTIVE } from './sidebarnavigationmenu.types';

type TSideBarNavigationMenu = {
    isSidebarNavigationMenuActive: boolean;
};

const initialState: TSideBarNavigationMenu = {
    isSidebarNavigationMenuActive: false,
};

const sidebarNavigationMenuReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<TSideBarNavigationMenu>>{},
) => {
    switch (type) {
        case IS_SIDEBAR_NAVIGATION_MENU_ACTIVE:
            return {
                ...state,
                isSidebarNavigationMenuActive: payload.isSidebarNavigationMenuActive,
            };
        default:
            return state;
    }
};

export const showSidebarNavigationMenu = () => (dispatch: Function) => {
    dispatch(setScreenController(ScreenControllerTypes.SIDEBAR_NAVIGATION_MENU_SCREEN));
    dispatch(
        setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_SIDEBAR_NAVIGATION_MENU_TASKS),
    );
    dispatch(enableGhostMode());
    dispatch(setIsSidebarNavigationMenuActiveAction(true));
};

export const hideSidebarNavigationMenu = () => (dispatch: Function) => {
    dispatch(setScreenController(ScreenControllerTypes.GUIDE));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_GUIDE_TASKS));
    dispatch(disableGhostMode());
    dispatch(setIsSidebarNavigationMenuActiveAction(false));
};

export default sidebarNavigationMenuReducer;
